import { render, staticRenderFns } from "./error-modal.vue?vue&type=template&id=452e74fd&"
import script from "./error-modal.vue?vue&type=script&lang=js&"
export * from "./error-modal.vue?vue&type=script&lang=js&"
import style0 from "./error-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzIconArrowThin: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/icons/icon-arrow-thin/index.js').default,RzIconWarningTriangle: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/icons/icon-warning-triangle/index.js').default,RzButton: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/button/index.js').default,RzModal: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/modal/index.js').default})
